import { Card, makeStyles } from "@material-ui/core";
import { useMinio, useTtmsAuth } from "@tt/ttms-react-core";
import DOMPurify from "dompurify";
import * as React from "react";
import { Show, SimpleShowLayout, useDataProvider } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";
import VideoContainer from "../../components/videoJS/videoContainer";
import ApprovedComments from "../comment/ApprovedComments";

const useStylesVideoField = makeStyles(() => ({
  videoCard: {
    maxWidth: "400px",
  },
  videoThumbnail: {
    minHeight: "200px",
  },
  videoWrapper: {
    position: "relative",
    width: "100%",
    //paddingBottom: `${9 / 16 * 100}%`,
    //height: 0
  },
}));

const VideoShow = (props) => {
  const { user } = useTtmsAuth();

  setTimeout(() => {
    if (user != null) {
      let videoLink = localStorage.getItem("showVideos");
      if (videoLink != null) {
        localStorage.removeItem("showVideos");
      }
    }
  }, 1000);

  let extendedProps = {
    videoId: props.id,
  };

  return (
    <AuthorizedCheck isAdmin={false}>
      <Show actions={<VideoShowActions />} {...props} title={<VideoDetailTitle />}>
        <SimpleShowLayout>
          {/* <MinioField source='thumbnailPath' >
                      <ImageField />
                  </MinioField> */}
          <VideoField />
          <HtmlField source="description" />
          <ApprovedComments {...extendedProps} />
        </SimpleShowLayout>
      </Show>
    </AuthorizedCheck>
  );
};

const VideoDetailTitle = ({ record }: any) => {
  //return <span>Video: {record ? `"${record.title}"` : ""}</span>;
  return record.title;
};

const VideoShowActions = () => null;

// const HtmlField = (props) => {
//   const { record, source } = props;
//   const html = record[source];
//   return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
// };

const HtmlField = (props) => {
  const { record, source } = props;
  const html = record[source];
  const sanitizedHtml = DOMPurify.sanitize(html);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>;
};

export const VideoField = (props) => {
  const dp = useDataProvider();
  const classes = useStylesVideoField();
  const minio = useMinio();

  let {
    record: { videoPath },
  } = props;
  //let { record: { videoPath, thumbnailPath } } = props;
  //thumbnailPath = minio.convertUrl(thumbnailPath);
  videoPath = minio.convertUrl(videoPath);

  const createVideoRecord = async () => {
    await dp
      .create("VideoRecords", {
        data: {
          videoId: props.record.id,
        },
      })
      .catch((error) => {
        console.log("VideoRecord sırasında hata var.");
      });
  };

  return (
    <Card className={classes.videoCard}>
      <div className={classes.videoWrapper}>
        <video
          controls
          controlsList="nodownload"
          width="100%"
          //poster={thumbnailPath}
          onPlay={() => {
            createVideoRecord();
          }}
        >
          <source src={videoPath} type="video/mp4" />
          Sorry, your browser doesn't support embedded videos.
        </video>
        <VideoContainer {...props} />
      </div>
    </Card>
  );
};

export default VideoShow;
